<template>
    <div id="lock"><slot></slot></div>
</template>

<script>
import lock from "@/services/lock";
import { mapGetters } from "vuex";

export default {
    props: {
        planoId: {
            type: Number,
            required: true
        }
    },
    data: () => ({
        isMounted: false,
        details: {
            deadline: undefined,
            lockedBy: undefined,
            loading: true
        }
    }),
    mounted() {
        this.isMounted = true;
        this.startLockPolling();
    },
    beforeDestroy() {
        this.isMounted = false;
    },

    computed: {
        ...mapGetters("currentUser", ["currentUser"]),
        isOwned() {
            return !this.details.loading && (this.details.lockedBy && this.details.lockedBy.id) === this.currentUser.user.id;
        }
    },

    methods: {
        // if the logged user owns the planogram, wait until 5 seconds before the deadline.
        // Otherwise wait until 5 seconds after the deadline.
        async waitForDeadline() {
            const now = Date.now();
            const targetTimestamp = this.details.deadline * 1000 + (this.isOwned ? -5000 : 5000);

            if (now < targetTimestamp) {
                await new Promise(r => setTimeout(r, targetTimestamp - now));
            } else {
                await new Promise(r => setTimeout(r, 1000));
            }
        },

        // regularly request the backend to lock the planogram
        // until this component is unmounted
        async startLockPolling() {
            while (this.isMounted) {
                try {
                    this.details.loading = true;
                    const res = await lock.planogram(this.planoId);
                    this.details = {
                        deadline: res.deadLine,
                        lockedBy: res.lockedBy
                    };
                } catch (err) {
                    // polling must not stop even with connection errors.
                    // but failing requests must lock the planogram
                    console.error(err);
                    this.details = {
                        deadline: undefined,
                        lockedBy: undefined
                    };
                } finally {
                    this.details.loading = false;
                }

                await this.waitForDeadline();
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// lock.vue?4b614f26